var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"overlay"}},[(_vm.show)?_c('div',{staticClass:"mp-overlay",class:`mp-overlay--${_vm.type}`,on:{"click":function($event){return _vm.$emit('click', $event)}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }